// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1e0n3","row":"Node_row__2LzOX","label":"Node_label__1Jxs9","footer":"Node_footer__3WHwD"};